export default {
  items: [
    {
      divider: true
    },
    {
      divider: true
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      name: 'Customers',
      url: '/customers/list',
      icon: 'icon-people',
      children: [
        {
          name: 'Office List',
          url: '/customers/list',
          icon: 'icon-list'
        },
        {
          name: 'Office Modules',
          url: '/customers/modules',
          icon: 'icon-layers'
        },
				{
					name: 'Create Project',
					url: '/customers/create-project',
					icon: 'icon-home'
				},
				{
					name: 'Create Office',
					url: '/customers/create-office',
					icon: 'icon-home'
				},
				{
					name: 'Group of Companies',
					url: '/customers/company-groups',
					icon: 'fa fa-users'
				},
				{
					name: 'Companies',
					url: '/customers/companies',
					icon: 'icon-home'
				},

      ]
    },
    {
      name: 'Billings',
      url: '/billings/setup',
      icon: 'icon-calendar',
      children: [
        {
          name: 'Billing Setup',
          url: '/billings/setup',
          icon: 'icon-wrench'
        },
        {
          name: 'Invoice',
          url: '/billings/invoice',
          icon: 'fa fa-file-text-o'
        },
        {
          name: 'Payment',
          url: '/billings/payment',
          icon: 'fa fa-dollar'
        },
				{
					name : 'Due Status',
					url : '/billings/due-status',
					icon : 'fa fa-dollar'
				}
      ]
    },
    {
      name: 'Settings',
      url: '/settings/list',
      icon: 'icon-settings',
      children: [
        {
          name: 'Version',
          url: '/settings/version',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Module',
          url: '/settings/module',
          icon: 'fa fa-cubes'
        },
        {
          name: 'Version Configurator',
          url: '/settings/configurator',
          icon: 'fa fa-cogs'
        }
      ]
    },
		{
			name: 'Resellers',
			url: '/resellers/list',
			icon: 'icon-people',
			children: [
				{
					name: 'List',
					url: '/resellers/list',
					icon: 'icon-list'
				}
			]
		},
		{
			name: 'Orders',
			url: '/purchase-orders/list',
			icon: 'fa fa-file-text',
			children: [
				{
					name: 'P.O. List',
					url: '/purchase-orders/list',
					icon: 'icon-list'
				},
				{
					name: 'Create P.O.',
					url: '/purchase-orders/create',
					icon: 'icon-plus'
				},
				{
					name: 'Delivery Receipt',
					url: '/purchase-orders/delivery-receipts/create',
					icon: 'fa fa-truck'
				}
			]
		},
		{
			name: 'Customer Support',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Password Reset',
					url: '/customer-support/password-reset',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Support Management',
					url: '/customer-support/support-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Clone Temporary Allocations',
					url: '/customer-support/temporary-allocations/clone',
					icon: 'fa fa-clone'
				},
				{
					name: 'Report Archive',
					url: '/customer-support/report-archive',
					icon: 'fa fa-archive'
				}
			]
		},
		{
			name: 'Payroll',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Payroll Manager',
					url: '/payroll/payroll-manager',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Provident Fund',
					url: '/payroll/provident-fund',
					icon: 'fa fa-life-ring'
				}

			]
		},
		{
			name: 'General Settings',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Mobile Punch Settings',
					url: '/general-settings/mobile-punch',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Overtime Settings',
					url: '/general-settings/overtime-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Fiscal Year Settings',
					url: '/general-settings/fiscal-year',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Report Settings',
					url: '/general-settings/report-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Parking Management',
					url: '/general-settings/parking-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Membership Management',
					url: '/general-settings/membership-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Site Management',
					url: '/general-settings/site-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Attendance Settings',
					url: '/general-settings/attendance-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Line Manager Settings',
					url: '/general-settings/line-manager-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Location Tracking',
					url: '/general-settings/location-tracking',
					icon: 'fa fa-life-ring'
				}
			]
		},

  ]
}
